<template>
  <div
    id="devmg"
    v-loading.fullscreen.lock="loading"
    element-loading-text="Waiting...."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    align="left"
  >
    <el-row>
      <div class="up">
        <el-input placeholder="输入分组名称" v-model="group_name" class="input-with-select">
          <el-button slot="append" icon="el-icon-plus" @click="func_addgoupKey">添加分组</el-button>
          <el-button slot="append" icon="el-icon-tickets" @click="getPlayList">播放菜单</el-button>
        </el-input>
      </div>
    </el-row>

    <el-table :data="tableData" style="width: 1100px" highlight-current-row border>
      <el-table-column type="index" width="100" label="编号 "></el-table-column>
      <el-table-column prop="name" label="分组名字 " width="250"></el-table-column>
      <el-table-column prop="dlist.length" label="设备个数 " width="100"></el-table-column>
      <el-table-column label="操作[Operation]" align="center" width="550">
        <template slot-scope="scope">
          <el-button
            type="warning"
            icon="el-icon-edit"
            @click.native.prevent="EditRow(scope.$index, tableData)"
            size="small"
            plain
          >编辑</el-button>
          <el-button
            type="warning"
            icon="el-icon-edit"
            @click.native.prevent="EditurlRow(scope.$index, tableData)"
            size="small"
            plain
          >修改视频</el-button>
         <el-button
            type="warning"
            icon="el-icon-edit"
            @click.native.prevent="viewurlRow(scope.$index, tableData)"
            size="small"
            plain
          >预览视频</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click.native.prevent="goDeleteRow(scope.$index, tableData)"
            size="small"
            plain
          >删除</el-button>
        </template>
      </el-table-column>
      <el-table-column label="实时播放" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="setPlay(scope.$index, tableData)"
            type="primary"
            size="small"
            plain
          >分组点播</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="编辑设备"
      :visible.sync="dialogVisible_adddevice"
      :before-close="handleClose_adddevice"
      width="800px" >
      <el-transfer
        v-model="valueT"
        filterable
        :titles="['所有设备', '选中的']"
        :button-texts="['到左边', '到右边']"
        :format="{
				  noChecked: '${total}',
				  hasChecked: '${checked}/${total}'
				}"
        :data="Tdata"
      ></el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="func_save_group">保存分组</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="分组点播"
      :visible.sync="dialogVisible_adddevice2"
      :before-close="handleClose_adddevice2"
      width="800px"     >
    <el-form ref="form" :model="form" label-width="80px" align="left">
       <myTransfer  style="margin-left: 20px; " v-model="valueT2" :inputList="Tdata2"  @countLength="countLength"   >
                   <span slot-scope="{option}">{{ option.label }}</span>
       </myTransfer>
        <el-form-item label="文件间隔" style="margin-top:50px">
          <el-tooltip class="item" effect="dark" content="以秒为单位，默认1秒; 一个文件播放完毕之后 间隔多少秒再播下一个" placement="right-start">
            <el-input-number v-model="form.space" @change="countLength" :min="1"></el-input-number>
          </el-tooltip>
        </el-form-item>
        <el-row class="fucko">
          <el-col :span="6">
            <el-form-item label="播放次数" >
				<el-tooltip class="item" effect="dark" content="整个列表循环播放多少遍" placement="right-start">
					<el-input-number v-model="form.num" @change="countLength" :min="1"></el-input-number>
				</el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="总时长">
          <el-input-number v-model="form.length3"></el-input-number>
        </el-form-item>
      </el-form>
      <span style="text-align:center">
        <el-button type="success" @click="startGroup">播放</el-button>
      </span>
    </el-dialog>

    <el-drawer title="播放列表" :visible.sync="drawer" direction="btt">
      <div style="overflow-y:auto;height:200px">
        <div v-for="(item,index) in playList" :key="index" style="padding-left:20px">
          <!-- <div v-for="(item2,index2) in item.Name" :key="index2">{{item.Name}}</div> -->
          <div>播放序列：{{item.Name}} 每个文件播放间隔： {{item.jiange}} 播放循环次数：{{item.playmode}}</div>
          <el-button type="warning" @click="stopGroup(item)" size="small" plain>停止</el-button>
        </div>
      </div>
    </el-drawer>
    <el-dialog
      title="编辑设备"
      :visible.sync="dialogVisible_adddevice"
      :before-close="handleClose_adddevice"
      width="800px" >
      <el-transfer
        v-model="valueT"
        filterable
        :titles="['所有设备', '选中的']"
        :button-texts="['到左边', '到右边']"
        :format="{
    		  noChecked: '${total}',
    		  hasChecked: '${checked}/${total}'
    		}"
        :data="Tdata"
      ></el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="func_save_group">保存分组</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑视频直播地址mu38地址url"
      :visible.sync="dialogVisible_adddevice3"
      width="800px"     >
        <div>
          <span>{{mu38gname}}</span>
          <br />
          <el-input placeholder="请输入内容"  maxlength=200  minlength=30 show-word-limit v-model="mu38url">
            <template slot="prepend">Http://xxxxxx.mu38?***</template>
          </el-input>
        </div>
        <br>
        <div style="text-align:right">
          <el-button type="success" @click="dialogVisible_adddevice3 = false">取消</el-button>
          <el-button type="success" @click="save_mu38">保存</el-button>
        </div>
    </el-dialog>
    <el-dialog
      :title=mu38gname
      :visible.sync="dialogVisible_adddevice4"
      width="800px"     >
      <video   width="760px"  :src="mu38url" controls></video>
        <div style="text-align:right">
          <el-button type="success" @click="dialogVisible_adddevice4 = false">取消</el-button> 
        </div>
    </el-dialog>
  </div>
</template>

<script>
import myTransfer from './myTransfer.vue';
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;

export default {
  data() {
    return {
      form: {
        space: 0,
        kind: "随机播放",
        num: 1,
        length1: 0,
        length2: 0,
        length3: 0,
        mode:0,
        port: "",
        ip: "",
        fileStr: "",
        seedStr: "",
        filelist: {
          data: [],
          value: []
        },
      },
      drawer: false,
      playList: [],
      playNameList: [],
      tableDatatasklist: [],
      tableDatafilelist: [],
      options: [],
      nodeid: "",
      group_name: "",
      tableData: [],
      dialogVisible_adddevice: false,
      dialogVisible_adddevice2: false,
      name_adddevice: "",
      seed_adddevice: "",
      seed_ofnode: "",
      tag1: "自定义标签A可选",
      tag2: "自定义标签B可选",
      type: "1",
      device_status: "1",
      sqr_adddevice: "",
      save_backdata: "",
      dialogVisible_save_back: false,
      dialogVisible_save_back_detail: false,
      valueT: [],
      Tdata: [],
      valueT2: [],
      Tdata2: [],
      forgid: -1,
      loading: false,
      dialogVisible_adddevice3:false,
      mu38url:"",
      mu38id:1,
      mu38gname:"",
      dialogVisible_adddevice4:false
    };
  },
  created() {
      this.reflash_devlist();
  },
  components: {
    myTransfer
  },
  methods: {
    save_mu38(){
        let data = new FormData();
        data.append("id", sessionStorage.getItem("id"));
        data.append("token", sessionStorage.getItem("token"));
        data.append("gid", this.mu38id );
        data.append("msurl",this.mu38url);
        axios
           .post("/user/fnckukei/savemu38_info", data)
           .then(
             function(res) {
               if (res.data.res) {
                  this.$notify.success({
                    title: "Info",
                    message: "保存成功",
                    showClose: true
                  });
                   this.reflash_devlist();
                  this.dialogVisible_adddevice3 = false;
               }else{
                  this.$notify.success({
                    title: "Info",
                    message: "失败",
                    showClose: true
                  });
                  this.dialogVisible_adddevice3 = false;
               }
                 this.dialogVisible_adddevice3 = false;
             }.bind(this)
           )
           .catch(function(res) {
             console.log(res);
           });
    },
    viewurlRow(index, rows){
        this.dialogVisible_adddevice4 = true;
        this.mu38url=rows[index].msurl;
        this.mu38id=rows[index].gid;
        this.mu38gname=rows[index].name;
    },
    EditurlRow(index, rows) {
      this.dialogVisible_adddevice3 = true;
      if(rows[index].msurl == "none"){
        this.mu38url="还没设置mu38u 直播地址";
        this.mu38id=rows[index].gid;
        this.mu38gname=rows[index].name;
      }else{
        this.mu38url=rows[index].msurl;
        this.mu38id=rows[index].gid;
        this.mu38gname=rows[index].name;
      }
    },
    getPlayList() {
      let data = new FormData();
     data.append("id", sessionStorage.getItem("id"));
     data.append("token", sessionStorage.getItem("token"));
      axios
        .post("/user/tmplistpl", data)
        .then(
          function(res) {

            if (res.data.res) {
              if (res.data.tps.length > 0 ) {
                  this.playList = res.data.tps;
                  this.drawer = true;
              }
            } else {
              this.$notify.success({
                title: "Info",
                message: "当前没有正在播放的序列",
                showClose: true
              });
              this.drawer = false;
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
	  countfuck(){
      this.countLength();
	  },
    stopGroup(item) {
      console.log(item);
      this.loading = true;
     let data = new FormData();
     data.append("id", sessionStorage.getItem("id"));
     data.append("token", sessionStorage.getItem("token"));
     data.append("tpid", item.tmpid);
      axios
        .post("/user/tmpstoppl", data)
        .then(
          function(res) {
            if (res.data.res) {
              console.log(res.data);
              setTimeout(() => {
                this.getPlayList();
                this.loading = false;
              }, 5000);
            } else {
              this.loading = false;
              this.$notify.success({
                title: "Info",
                message: "获取失败",
                showClose: true
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },

    goDeleteRow(index, rows) {
        this.$confirm("此操作将永久删除该分组, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          this.deleteRow(index, rows);
        })
        .catch(() => {});
    },
    startGroup() {
      if( this.form.num > 0 ){
        this.form.mode = this.form.num;
      }
      this.form.kind =  this.form.mode;
        var tempArr = [];
        for (var i in this.valueT2) {
          tempArr.push(this.valueT2[i]);
        }
        this.form.fileStr = tempArr.join("|");
        if (!this.form.fileStr) {
          this.$message({
            type: "warning",
            message: "没有选择文件"
          });
          return;
        }
        var tmpfileids = [];
        for (var i in this.Tdata2) {
          if(this.valueT2.includes(this.Tdata2[i].key )){
            tmpfileids.push(this.Tdata2[i].id);
          }
        }
         console.log(tmpfileids);
        this.form.fileStr = tmpfileids.join("|");
         console.log(this.form.fileStr );
        let data = new FormData();
        data.append("id", sessionStorage.getItem("id"));
        data.append("token", sessionStorage.getItem("token"));
        data.append("playmode", this.form.mode);
        data.append("len", this.form.length3);
        data.append("jiange", this.form.space);
        data.append("fileids", this.form.fileStr); //搞定 √
        data.append("snids", this.form.seedStr); //搞定 √
        axios
            .post("/user/tmpstartpl", data)
            .then(
              function(res) {
                if (res.data.res) {
                  this.$notify.success({
                    title: "Info",
                    message: "播放成功",
                    showClose: true
                  });
                } else {
                  console.log(res.data);
                  this.$notify.success({
                    title: "Info",
                    message: "添加出现异常",
                    showClose: true
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
      this.dialogVisible_adddevice2 = false;
    },
    countNum() {
      this.form.length2 = this.form.length1 + this.form.space * (this.valueT2.length - 1);
    },
    countSpace() {
      this.form.length2 = this.form.length1 + this.form.space * (this.valueT2.length - 1);
      this.form.length3 = this.form.length2* this.form.num + this.form.space * this.form.num;
    },
    countLength() {
      this.form.length1 = 0;
      for (var i = 0; i < this.tableDatafilelist.length; i++) {
        for (var j = 0; j < this.valueT2.length; j++) {
          if (
            this.valueT2[j] ==
            this.tableDatafilelist[i].url + "," + this.tableDatafilelist[i].len
          ) {
            this.form.length1 += parseInt(this.tableDatafilelist[i].len);
          }
        }
      }
      this.countSpace();
    },
    task_mode_change() {
      if (this.form.kind == "0") {
        this.form.num = 0;
        this.form.length3 = this.form.length2;
      } else {
        this.form.num = 1;
      }
    },
    setPlay(index, rows) {
      this.get_file_list();
      var tempArr = [];
      tempArr = rows[index].idlist;
      this.form.seedStr = tempArr.join("|");
      console.log(this.form.seedStr );
      this.dialogVisible_adddevice2 = true;
      this.valueT2=[];
    },
    func_addgoupKey() {
      this.dialogVisible_adddevice = false;
      if (this.group_name.trim() == "") {
        this.$notify.success({
          title: "Info",
          message: "分组字不能为空",
          showClose: true
        });
        return;
      }
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("gname", this.group_name);
      axios
        .post("/user/addgname", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.reflash_devlist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "添加出现异常",
                showClose: true
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    func_save_group() {
      console.log(this.valueT.length);
      if (this.valueT.length == 0) {
        return;
      }
      let strseed = "";
      if (this.valueT.length == 0) {
        this.$notify.success({
          title: "Info",
          message: "分组为空不能保存",
          showClose: true
        });
        return;
      }


      this.Tdata.forEach(item => {
        if(this.valueT.includes(item.key)){
          strseed += item.id;
          strseed += "|";
        }
      });
      strseed = strseed.substr(0, strseed.length - 1);
      console.log(strseed);

      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("gid", this.forgid);
      data.append("devids", strseed);
      axios
        .post("/user/editgdevs", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.reflash_devlist();
              this.dialogVisible_adddevice = false;
              this.$notify.success({
                title: "Info",
                message: "修改成功",
                showClose: true
              });
            } else {
              this.$notify.success({
                title: "Info",
                message: "添加出现异常",
                showClose: true
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    func_addgoup() {

    },
    func_adddevic() {
      this.dialogVisible_adddevice = true;
    },

    deleteRow(index, rows) {
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("gid",  rows[index].gid );
      data.append("token", sessionStorage.getItem("token"));
      axios
        .post("/user/delgroup", data )
        .then(
          function(res) {
            if (res.data.res) {
              this.$notify.success({
                title: "Info",
                message: "删除成功",
                showClose: true
              });
              rows.splice(index, 1);
              this.reflash_devlist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "删除失败",
                showClose: true
              });
            }
          }.bind(this)
        ).catch(function(res) {
          console.log(res);
        });
    },

    EditRow(index, rows) {
      this.dialogVisible_adddevice = false;
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("gid", rows[index].gid);
      axios
        .post("/user/fnckukei/getonegdevs",data).then( function(res) {
            if (res.data.res) {
              this.Tdata = res.data.dev_info;
              this.valueT = res.data.dev_info_S;
              this.forgid = rows[index].gid;
              this.dialogVisible_adddevice = true;
            }else{
              this.$notify.success({
                title: "Info",
                message: "添加出现异常1",
                showClose: true
              });
            }
          }.bind(this)
        ).catch(function(res) {
          console.log(res);
        });
    },
    handleClose_adddevice() {
      this.dialogVisible_adddevice = false;
    },
    handleClose_adddevice2() {
      this.dialogVisible_adddevice2 = false;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    reflash_devlist: function() {
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      axios
        .post("/user/listdetailgroups", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.tableData = res.data.list;
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    reflash_devlist2: function() {
      axios
        .get("/get_user_node.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd")
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.options = res.data.outlableid;

              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    get_file_list() {
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      axios
        .post("/user/listfile", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatafilelist = res.data.filelist;
              this.tableDatafilelist.forEach((item, index) => {
                item.filename = Base64.decode(item.filenamebase64);
                item.filesize = item.sizeStr;
              });
              const data = [];
              for (let i = 0; i < this.tableDatafilelist.length; i++) {
                data.push({
                  key:
                    this.tableDatafilelist[i].url +
                    "," +
                    this.tableDatafilelist[i].len,
                  label: this.tableDatafilelist[i].filename,
                  id: this.tableDatafilelist[i].id
                });
              }
              this.Tdata2 = data;

              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style   scoped>
.up {
  width: 910px;
  margin-left: 100px ;

  align: left;
}
.el-select .el-input {
  width: 200px;
}
.el-transfer {
  text-align: left;
}

#devmg {
  padding-top: 20px;
  width: 100%;
  align:left;
}
.el-table {
  margin-left: 100px ;
  margin-top: 20px;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/Group_mg.vue